interface EmotionData {
  label: string;
  value: number;
  color: string;
  gradient: string;
}

interface EmotionChartProps {
  compact?: boolean;
  data?: EmotionData[];
}

const emotions: EmotionData[] = [
  { label: 'Радость', value: 8, color: '#3ECFA0', gradient: 'linear-gradient(90deg, #3ECFA0, #2BA87F)' },
  { label: 'Печаль', value: 3, color: '#4A90E2', gradient: 'linear-gradient(90deg, #4A90E2, #357ABD)' },
  { label: 'Страх', value: 1, color: '#8B7AB8', gradient: 'linear-gradient(90deg, #8B7AB8, #6B5A98)' },
  { label: 'Гнев', value: 2, color: '#FF6B6B', gradient: 'linear-gradient(90deg, #FF6B6B, #EE5A52)' },
];

export default function EmotionChart({ compact = false, data }: EmotionChartProps) {
  const visibleEmotions = data ?? emotions;

  return (
    <div
      className="w-full rounded-3xl"
      style={{
        background: 'rgba(255,255,255,0.05)',
        border: '1px solid rgba(255,255,255,0.08)',
        padding: compact ? '16px 18px' : '22px 22px',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: compact ? '14px' : '18px' }}>
        {visibleEmotions.map((e) => (
          <div key={e.label} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontSize: compact ? '13px' : '14px', fontWeight: 500, color: '#F5F5F7', minWidth: compact ? '50px' : '58px' }}>{e.label}</span>
            <div style={{ flex: 1, height: compact ? '10px' : '12px', borderRadius: '6px', background: 'rgba(255,255,255,0.08)', overflow: 'hidden' }}>
              <div
                style={{
                  height: '100%',
                  width: `${(e.value / 10) * 100}%`,
                  background: e.gradient,
                  borderRadius: '6px',
                  transition: 'width 1s ease-out',
                }}
              />
            </div>
            <span style={{ fontSize: compact ? '14px' : '16px', fontWeight: 600, color: e.color, minWidth: '18px', textAlign: 'right' }}>{e.value}</span>
          </div>
        ))}
      </div>
      <p style={{ fontSize: '11px', color: '#6B7A94', marginTop: compact ? '10px' : '14px', textAlign: 'center' }}>Шкала от 1 до 10</p>
    </div>
  );
}
